// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7fbc6500","404":"f65da0c8","787":"0fef8e45","942":"a0956f33","980":"c780ab98"}[chunkId] + ".chunk.js";
};